var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadResults({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "82px",
    viewBox: "0 0 68 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Get-Started",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4-Upload-the-first-test-results",
    transform: "translate(-595.000000, -211.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-upload-test",
    transform: "translate(595.000000, 211.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3530862,13.9507389 L48.0525936,13.9507389 C46.3426108,13.9456527 44.957564,12.5606059 44.9524778,10.8506232 L44.9524778,1.55013054 L57.3530862,13.9507389 Z",
    id: "Path",
    fill: "#87D2F3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.550131, 1.453202)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8029557,12.4975369 L55.8029557,68.3004926 C55.7978695,70.0106207 54.4128227,71.3955222 52.7028399,71.4006084 L3.10011576,71.4006084 C1.390133,71.3955222 0.0050862069,70.0106207 0,68.3004926 L0,3.19704433 C0.0050862069,1.48706158 1.390133,0.102014778 3.10011576,0.0969285714 L43.402202,0.0969285714 L43.402202,9.39742118 C43.4074335,11.1074039 44.7924803,12.4924507 46.5024631,12.4975369 L55.8029557,12.4975369 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "41.8522167 31.0985222 41.8522167 34.1986379 24.8013621 34.1986379 24.8013621 29.5483916 41.8522167 29.5483916"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#183651",
    fillRule: "nonzero",
    points: "25 20 40.5008695 20 40.5008695 23.1001158 25 23.1001158"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    fill: "#183651",
    fillRule: "nonzero",
    points: "25 34 40.5008695 34 40.5008695 37.1001158 25 37.1001158"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy-2",
    fill: "#183651",
    fillRule: "nonzero",
    points: "25 49 32.5 49 32.5 52.1001158 25 52.1001158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4489458,12.8548793 L46.0483374,0.454125616 C45.757697,0.163339901 45.3634433,2.84217094e-14 44.9524778,2.84217094e-14 L4.65024631,2.84217094e-14 C2.08200246,2.84217094e-14 -3.16191517e-13,2.08200246 -3.16191517e-13,4.65024631 L-3.16191517e-13,69.7999746 C-3.16191517e-13,72.3682185 2.08200246,74.4502209 4.65024631,74.4502209 L54.2528251,74.4502209 C56.821069,74.4502209 58.9030714,72.3682185 58.9030714,69.7999746 L58.9030714,13.9507389 C58.9030714,13.5396281 58.7397315,13.1455197 58.4489458,12.8548793 Z M55.8029557,69.7999746 C55.8029557,70.6560559 55.1089064,71.3501052 54.2528251,71.3501052 L4.65024631,71.3501052 C3.79416502,71.3501052 3.10011576,70.6560559 3.10011576,69.7999746 L3.10011576,4.65024631 C3.10011576,3.79416502 3.79416502,3.10011576 4.65024631,3.10011576 L43.4023473,3.10011576 L43.4023473,10.8504778 C43.4023473,13.4187217 45.4843498,15.5007241 48.0525936,15.5007241 L51.1527094,15.5007241 L51.1527094,12.4006084 L48.0525936,12.4006084 C47.1965123,12.4006084 46.5024631,11.7065591 46.5024631,10.8504778 L46.5024631,5.2919803 L55.8029557,14.5924729 L55.8029557,69.7999746 Z",
    id: "Shape",
    fill: "#183651",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#183651",
    strokeWidth: 2.5,
    fill: "#5B9CFF",
    cx: 51,
    cy: 65,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    stroke: "#183651",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    cx: 16,
    cy: 22,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    fill: "#5B9CFF",
    cx: 16,
    cy: 22,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    stroke: "#C5CEE8",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    cx: 16,
    cy: 36,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-9",
    stroke: "#C5CEE8",
    strokeWidth: 2.5,
    fill: "#FFFFFF",
    cx: 16,
    cy: 51,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,61.5194166 L51.9012219,56.3764389 C51.4034974,55.8745204 50.5966221,55.8745204 50.0987781,56.3764389 L45,61.5194166 L46.8024438,63.3374852 L49.7253354,60.3892561 L49.7253354,74 L52.2746646,74 L52.2746646,60.3892561 L55.1975562,63.3374852 L57,61.5194166 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadResults);
export default __webpack_public_path__ + "static/media/upload_results.cadffac40abfd5474e210b3a7615c789.svg";
export { ForwardRef as ReactComponent };